// 3x5 pixel font, original glyph designs
const G: Record<string, string> = {
  "0": "111101101101111", "1": "010110010010111", "2": "111001111100111", "3": "111001111001111",
  "4": "101101111001001", "5": "111100111001111", "6": "111100111101111", "7": "111001010010010",
  "8": "111101111101111", "9": "111101111001111", A: "010101111101101", B: "110101110101110",
  C: "011100100100011", D: "110101101101110", E: "111100110100111", F: "111100110100100",
  G: "011100101101011", H: "101101111101101", I: "111010010010111", J: "001001001101010",
  K: "101101110101101", L: "100100100100111", M: "101111111101101", N: "110101101101101",
  O: "010101101101010", P: "110101110100100", Q: "010101101111011", R: "110101110101101",
  S: "011100010001110", T: "111010010010010", U: "101101101101111", V: "101101101101010",
  W: "101101111111101", X: "101101010101101", Y: "101101010010010", Z: "111001010100111",
  ":": "000010000010000", "-": "000000111000000", "/": "001001010100100", ".": "000000000000010",
  "!": "010010010000010", "?": "110001010000010", "<": "001010100010001", ">": "100010001010100",
  " ": "000000000000000", "'": "010010000000000", "%": "101001010100101", "+": "000010111010000",
  "[": "110100100100110", "]": "011001001001011", "*": "101010111010101", "@": "111101111100011", _: "000000000000111",
};
import { currentLang } from "./i18n";
import { toFrench } from "./fr";
/** The text as it will be drawn: French when the language is French (the canvas texts are written in English). */
export const tr = (s: string) => {
  const audit = (globalThis as { __audit?: Set<string> }).__audit; // test hook: which strings does the game draw?
  if (audit) audit.add(s);
  if (s.charCodeAt(0) === 1) return s.slice(1); // "\u0001" prefix: draw as is (logos, labels already adapted)
  return currentLang() === "fr" ? toFrench(s) : s;
};
export function drawText(ctx: CanvasRenderingContext2D, s: string, x: number, y: number, color: string, scale = 1) {
  s = tr(s);
  ctx.fillStyle = color;
  let cx = x;
  for (const ch of s.toUpperCase()) {
    const g = G[ch] ?? G["?"];
    for (let i = 0; i < 15; i++) if (g[i] === "1") ctx.fillRect(cx + (i % 3) * scale, y + Math.floor(i / 3) * scale, scale, scale);
    cx += 4 * scale;
  }
}
export const textWidth = (s: string, scale = 1) => tr(s).length * 4 * scale - scale;
export function drawTextC(ctx: CanvasRenderingContext2D, s: string, cx: number, y: number, color: string, scale = 1) {
  drawText(ctx, s, Math.round(cx - textWidth(s, scale) / 2), y, color, scale);
}
